module.exports = "<bd-loader ng-show=\"vm.isLoading\"></bd-loader>\r\n<div id=\"hellosign_container\" ng-show=\"!vm.isLoading\"></div>\n";